import styled from 'styled-components'
import FontAwesome from 'react-fontawesome'

import { sizes } from './style-utils'

export const SettingsRow = styled.div`
    width: 100%;
    // max-width: ${sizes.tablet}px;
    background: #fff;
    color: #000;
    height: ${props => (props.height ? `${props.height}` : '44')}px;
    ${props => (props.columns ? `
        @media (max-width: 576px) {
            height: auto;
            min-height: ${(props.columns * 30) + (2 * 7)}px;
        }
    ` : '')}
    border-bottom: 1px solid #ccc;
    overflow: hidden;
    padding-top: 7px;
    padding-bottom: 7px;
    
    
    ${props => (props.isFirst ? `
        border-top: 1px solid #ccc;
    ` : '')}
`

export const SettingsRowEmpty = styled(SettingsRow)`
    background: ${props => (props.background ? `${props.background}` : '#F8F8F8')};
    border: none;
    padding 7px 15px;
    font-size: 12px;
    color: darkgray;
    min-height: 44px;
    height: auto;
`

export const TableViewCellTitle = styled(SettingsRow)`
    position: relative;
    background: ${props => (props.background ? `${props.background}` : '#F8F8F8')};
    border: none;
    padding 7px 15px 0;
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    color: darkgray;
`

export const TableViewCellTitleContent = styled.div`
    position: absolute;
    bottom: 4px;
    left: 15px;
`

export const SettingsTitle = styled.div`
    color: ${props => (props.disabled ? 'var(--fai-disabled-text-color)' : '#000')};
    display: inline-block;
    line-height: ${props => (props.height ? `${props.height - 14}` : '30')}px;
    min-height: ${props => (props.height ? `${props.height}` : '30')}px;
`

export const SettingsInputNumber = styled.input`
    width: 100%;
    text-align: right;
    border: none;
    line-height: 30px;
    color: #808080;
`

export const SettingsInputTime = styled.input`
    display: block;
    width: 100%;
    text-align: right;
    border: none;
    color: #808080;
    background-color: transparent;
`

export const SettingsInputMail = styled.input`
    width: 100%;
    text-align: right;
    border: none;
    color: #808080;
    line-height: 30px;
`

export const SettingsCurrentSelection = styled.div`
    width: 100%;
    line-height: 30px;
    display: inline-block;
    color: #808080;
    padding-right: 0;
`
export const SettingsSelectIcon = styled(FontAwesome)`
    line-height: 30px;
    vertical-align: top;
    color: #808080;
`

export const InfoButtonWrapper = styled.div`
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid rgba(0,0,0,0.3);
    top: 5px;
    position: relative;
    margin-left: ${props => (props.marginLeft ? props.marginLeft : '10px')};
`

export const InfoButton = styled.span`
    color: rgba(0,0,0,0.3);
    position: absolute;
    left: 5px;
    font-size: 15px;
    line-height: 20px;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Settings.js